export default{
  phones: [
    '+86 15928758550 （中国）',
    '+86 18349353270（中国）',
    '+1 4258668398 （美国）',
    '+880 1825459736 （孟加拉国）',
    '+60 182525593 （马来西亚）'
  ],
  menu:[
    {
      name: '首页',
      component: 'home'
    },
    {
      name:'服务',
      component: 'service',
      subMenu: [
        {
          title: '咨询服务',
          childrens: [
            { name: '企业战略与转型', component: 'enterprise' },
            { name: '业务流程', component: 'businessProcess' },
            { name: '数字化变革', component: 'digital' },
            { name: '企业应用', component: 'enterpriseApplication'},
            { name: 'CRM', component: 'crm'}
          ],
        },
        {
          title: '商业服务',
          childrens:[
            { name: '区块链', component: 'blockchains' },
            { name: '企业应用程序', component: 'businessApplication' },
            { name: '数据分析', component: 'dataAnalytics' },
            { name: 'AI 人工智能', component: 'artificialIntelligence' },
            { name: 'AI 视频制作', component: 'aiVideoProduction' }
          ]
        },
        {
          title: '技术服务',
          childrens: [
            { name: '软件开发与维护', component: 'softwareDevelopment' },
            { name: '企业移动', component: 'enterpriseMobility' },
            { name: '智能制造', component: 'intelligentManufacturing' },
            { name: '网络安全', component: 'networkSecurity' },
            { name: '全球化/本地化', component: 'globalization' },
            { name: '大数据', component: 'bigData' },
            { name: '物联网', component: 'internetThings' },
            { name: '云', component: 'cloud' },
          ]
        },
        {
          title: '外包服务',
          childrens: [
            { name: '应用外包', component: 'applicationOutsourcing' },
            { name: '业务流程外包', component: 'businessProcessOutsourcing' },
            { name: '客户服务', component: 'customerService' },
            // { name: '人力资源', component: 'humanResource' }
            { name: 'AI', component: 'humanResource' },
            { name: '游戏领域', component: 'gamingField' }
          ]
        }
      ]
    },
    {
      name:'行业',
      component: 'industry'
    },
    {
      name:'关于我们',
      component: 'aboutUs'
    },
    {
      name: '职业机会',
      component: 'jobs'
    },
    {
      name: '联系我们',
      component: 'contactUs'
    }
  ],
  languageList: [
    { name: '中文', code: 1, tag: 'zh' },
    { name: '英文', code: 2, tag: 'en' },
    { name: '日文', code: 8, tag: 'ja' }
  ],
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      // {
      //   imgUrl: require('../../assets/images/home/home-banner.jpg'),
      //   title: '全球IT服务公司',
      //   description: 'MaesInfo在中国和美国均设有分支机构，能够为全球客户提供服务，全天候服务，满足个人需求。',
      //   component: ''
      // },
      // {
      //   imgUrl: require('../../assets/images/home/home-banner2.jpg'),
      //   title: '大量中高级人才储备',
      //   description: '高质量和低成本的行动模式是按时间和预算执行的',
      //   component: ''
      // },
      {
        imgUrl: require('../../assets/images/home/home-banner4.jpg'),
        title: '智慧工厂服务',
        description: '',
        component: ''
      }
  ],
  // 服务列表
  serviceTitle: '迈思的服务',
  services: [
     // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称', size: 'big(比例最大), normal(比例第二大小), small(最小比例)'
    {
      imgUrl: require('../../assets/images/home/home-pic-14.jpg'),
      title: '工业自动化',
      description: '重构生产核心逻辑，告别繁琐重复工序',
      component: 'intelligentManufacturing',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-1.jpg'),
      title: '软件开发与维护',
      description: '随着企业信息化的不断深入，信息系统变得庞大而复杂',
      component: 'softwareDevelopment',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-2.jpg'),
      title: '人工智能',
      description: '人工智能引导着全球公司的革新',
      component: 'artificialIntelligence',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-3.jpg'),
      title: '物联网',
      description: ' 物联网被视为是互联网之后新的IT革命浪潮',
      component: 'internetThings',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-4.jpg'),
      title: '区块链',
      description: '区块链是一种新的计算机技术，用于各种应用，如分布式数据存储',
      component: 'blockchains',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-5.jpg'),
      // title: '人力资源',
      // description: '人力资源外包服务是一个新的人才管理和服务方式',
      title: 'AI',
      description: '数据之海中的AI，为你开启无限可能。',
      component: 'humanResource',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-6.jpg'),
      title: '大数据',
      description: '今天，数据植根于我们生活的每个角落比以往任何时候都多。',
      component: 'bigData',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-7.jpg'),
      title: '数字化变革',
      description: '在科技飞速发展的基础下，世界已经发生了深远的变化。并随时能适应最新科技的发展',
      component: 'digital',
      size: 'small'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-8.jpg'),
      title: '企业战略与转型',
      description: '业务转型是一个管理策略意味着战略变革',
      component: 'enterprise',
      size: 'normal'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-9.jpg'),
      title: '应用外包',
      description: 'MaesInfo的软件开发服务包括应用程序开发和定制产品发展。',
      component: 'applicationOutsourcing',
      size: 'big'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-10.jpg'),
      title: '数据分析',
      description: 'Maesinfo使用先进的大数据分析术加速利润增长并在数字经济时代中取得成功',
      component: 'dataAnalytics',
      size: 'big'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-11.jpg'),
      title: '企业移动',
      description: '高效的办公环境，成本节约和整合资源。',
      component: 'enterpriseMobility',
      size: 'normal'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-12.jpg'),
      title: '网络安全',
      description: '在互联网时代，网络安全至关重要到商业运作。',
      component: 'networkSecurity',
      size: 'normal'
    },
    {
      imgUrl: require('../../assets/images/home/home-pic-13.jpg'),
      title: '全球化/本地化',
      description: '迈思信息技术有限公司。 是一家创新的服务公司专门为客户提供智能IT解决方案的知名企业',
      component: 'globalization',
      size: 'normal'
    }
  ],
  //  行业信息
  industryTitle: '行业',
  industry: [
    // icon: '图标地址', title: '标题'， component: '点击跳转组件名称'
    {
      icon: require('../../assets/images/home/home-icon-1.png'),
      title: '银行',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-2.png'),
      title: '高科技',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-3.png'),
      title: '保险',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-4.png'),
      title: '金融',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-5.png'),
      title: '资本市场',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-6.png'),
      title: '软件',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-7.png'),
      title: '能源',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-8.png'),
      title: '互联网',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-9.png'),
      title: '汽车',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-10.png'),
      title: '医疗健康',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-11.png'),
      title: '旅行',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-12.png'),
      title: '教育',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-13.png'),
      title: '媒体娱乐',
      component: 'industry'
    },
    {
      icon: require('../../assets/images/home/home-icon-14.png'),
      title: '零售',
      component: 'industry'
    }
  ],
  footer: {
    p1: `+86(028) 6593-5363 （中国）`,
    p2: `+86 400-871-8663 （中国）`,
    p3: `+86 15928758550 （中国）`,
    p4: `+86 18349353270（中国）`,
    p5: `+1 4258668398 （美国）`,
    p6: `+880 1825459736 （孟加拉国）`,
    p7: `+60 182525593 （马来西亚）`,
    tell: `通过Me联系我们`,
    phone: ' 183-4935-3270 / 400-871-8663',
    copyRight: 'MaesInfo(TM) Copyright© 2005-2023 MaesInfo Corporation. All rights reserved'
  }
}
